import { ButtonMain } from "@/modules/common/components/button"
import { RegisterCard } from "../register-card"
import CulturesImg from '@@/home/images/cultures.jpg';
import CalculatorImg from '@@/home/images/calculator.jpg';
import styles from './index.module.sass'
import { DiContainer } from "@/modules/di/di-container";
import { AuthService } from "@/modules/auth/services/auth.service";
const authService = DiContainer.get(AuthService);

export const RegisterIntro = ({ setActiveStep }: { setActiveStep: (val: number) => void }) => {
  const onSignUp = (param?: { user_type: 'seller' | 'buyer' }) => authService.signUpInSso({ user_type: param?.user_type });
    return (
        <>
        <RegisterCard
          title="владелец агрокультур"
          image={CulturesImg}
          content={
            <div className={styles.cardContent}>
              <span>возможности:</span>
              <ul>
                <li>Учет хранения агрокультур</li>
                <li>Миксования агрокультур</li>
                <li>Анализ стоимости ваших агрокультур</li>
                <li>Продавать агрокультуры по наилучшим ценам</li>
              </ul>
            </div>
          }
          actions={
            <ButtonMain
              className={styles.cardButton}
              label="продолжить как владелец агрокультур"
              onClick={onSignUp}
            />
          }
        />
        <RegisterCard
          title="покупатель"
          image={CalculatorImg}
          content={
            <div className={styles.cardContent}>
              <span>возможности:</span>
              <ul>
                <li>Принимать онлайн заявки продажи зерна</li>
                <li>Создавать свои офферы на покупку зерна</li>
              </ul>
            </div>
          }
          actions={
            <ButtonMain
              className={styles.cardButton}
              label="оставить заявку на регистрацию в системе"
              onClick={() => onSignUp({ user_type: 'buyer' })}
            />
          }
        /></>
    )
}